import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AppSettings } from '../shared/app-settings';
import { of } from 'rxjs';

/**
 * Route guard for System Admin Portal
 * Only allows access to users with InternalAdmin or SystemAdmin role
 */
@Injectable()
export class SystemAdminGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot) {
        // Check if user is logged in
        const token = localStorage.getItem(AppSettings.StorageKeys.Token);
        if (!token) {
            this.router.navigate(['/login']);
            return of(false);
        }

        // Check if user has System Admin role
        if (!this.isSystemAdmin()) {
            // Redirect to home page with error message
            this.router.navigate(['/']);
            console.warn('Unauthorized access attempt to System Admin portal');
            return of(false);
        }

        return of(true);
    }

    /**
     * Check if current user has SystemAdmin module access with 'new' permission
     */
    private isSystemAdmin(): boolean {
        try {
            const userStr = localStorage.getItem(AppSettings.StorageKeys.User);
            if (!userStr) return false;

            const user = JSON.parse(userStr);
            
            // UserAccess is an array of module access objects
            const userAccess = user.userAccess || [];
            // Check if user has SystemAdmin module (moduleID: 999) with 'new' permission
            // Note: 'new' can be boolean (true) or int (1) depending on data source
            const hasSystemAdminAccess = userAccess.some((access: any) => 
                access.moduleID === 999 && (access.new === true || access.new === 1)
            );
            
            if (hasSystemAdminAccess) {
                console.log('SystemAdmin access granted');
            } else {
                console.warn('SystemAdmin access denied - missing SystemAdmin module with new=true');
            }
            
            return hasSystemAdminAccess;
        } catch (error) {
            console.error('Error checking system admin role:', error);
            return false;
        }
    }
}
